import { render, staticRenderFns } from "./ScoreDetailPage.vue?vue&type=template&id=5d1ab957"
import script from "./ScoreDetailPage.vue?vue&type=script&lang=js"
export * from "./ScoreDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports